/*eslint-disable*/
import parser from 'html-react-parser';
import moment from 'moment';
import React, { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { AiFillHeart, AiOutlineHeart } from 'react-icons/ai';
import { BiTransfer } from 'react-icons/bi';
import { CiCircleInfo } from 'react-icons/ci';
import { FaCrown } from 'react-icons/fa';
import { IoLogoWhatsapp } from 'react-icons/io';
import { MdEmail, MdLocationOn, MdPhoneInTalk } from 'react-icons/md';
import { TbCalendarTime } from 'react-icons/tb';
import { TiStarFullOutline } from 'react-icons/ti';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { imageUrl } from '../../config/apiUrl';
import { restrictOnlyUserActions } from '../../Helper/restrictActions';
import { useFavoriteEntityMutation, usePostApiMutation } from '../../store/apiSlice/apiSlice';
import { updateUser } from '../../store/auth/authSlice';
import { usdToOther } from '../../utils/helpers';
import ElasticCarousel from '../ElasticCarousel';
import Tooltip from '../Tooltip';
import classes from './EventCard.module.css';

const EventCard = ({ type, data = {}, onEmailClick = () => null, refetch }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation('webCommon');
  const { selectedLanguage } = useSelector((state) => state.languageReducer);
  const { currency } = useSelector((state) => state.converterReducer);
  const { direction } = useSelector((state) => state.languageReducer);
  const { user, isLogin } = useSelector((state) => state.authReducer);
  const navigate = useNavigate();
  const feature = data?.isFeatured || data?.isPremium;

  const [onFavorite, { isLoading: isFavoriting }] = useFavoriteEntityMutation();
  const [postApiFunc] = usePostApiMutation();

  const handleCompare = async (data) => {
    const onlyCompareEvent = user?.compareList?.filter((item) => item?.type == 'Event');
    const ifAlreadyExist = onlyCompareEvent?.find((item) => item?.entity == data?._id);
    if (!ifAlreadyExist && onlyCompareEvent?.length >= 3) return toast.error(t('toast.error'));

    const response = await postApiFunc({
      url: `users/compare/add`,
      method: 'POST',
      tag: `compareListFront`,
      data: {
        id: data?._id,
        type: 'event'
      }
    });
    if (response?.data) {
      dispatch(updateUser(response?.data?.data));
      toast.success(
        `${t('eventCard.toast.event')} ${
          ifAlreadyExist ? t('eventCard.toast.removedFrom') : t('eventCard.toast.addedIn')
        } ${t('eventCard.toast.success')}`
      );
      refetch && refetch();
    }
  };
  const isFavorite = data?.favoriteBy?.includes(user?._id);

  const handleFavorite = async () => {
    if (isFavoriting) return;
    const res = await onFavorite({ id: data?._id, type: 'event' });
    if (res?.data) {
      // if (res?.data?.data?.favoriteBy?.includes(user?._id))
      if (res?.data?.data) {
        toast.success(t('eventCard.toast.eventRemoved'));
      } else {
        toast.success(t('eventCard.toast.eventAdded'));
      }
      refetch && refetch();
    }
  };

  const handleAction = () => {
    const isAllowedActions = restrictOnlyUserActions(user?.role);
    if (!isLogin) {
      navigate('/login');
    } else if (isAllowedActions) {
      return true;
    }
  };

  return (
    <>
      <style>
        {`
 
                    a {
          text-decoration: none;
          color: inherit;
        }
          a:hover {
            text-decoration: none;
            color: inherit;
          }
      `}
      </style>

      <div className={type === 'map' ? classes.cardMainMap : classes.cardMain}>
        <div className={type === 'map' ? classes.topSectionMap : classes.topSection}>
          <div className={classes.image}>
            <ElasticCarousel images={data?.images} navigateLink={`events/${data?.slug}`} />
            {type !== 'map' && (
              <div className={classes.iconWrap}>
                <Tooltip text={t('eventCard.tooltips.compare')}>
                  <div className={classes.iconWrapInner}>
                    <BiTransfer
                      onClick={(e) => {
                        e.preventDefault();
                        e?.stopPropagation();
                        e.nativeEvent.stopImmediatePropagation();
                        if (!handleAction()) return;
                        handleCompare(data);
                      }}
                      size={25}
                      fill={
                        user?.compareList?.find((e) => e?.entity == data?._id)
                          ? 'var(--action-icon-clr)'
                          : 'white'
                      }
                    />
                  </div>
                </Tooltip>
                <Tooltip
                  text={
                    isFavorite
                      ? t('eventCard.tooltips.removeFavorite')
                      : t('eventCard.tooltips.addFavorite')
                  }>
                  {isFavorite ? (
                    <div className={classes.iconWrapInner}>
                      {' '}
                      <AiFillHeart
                        onClick={(e) => {
                          e.preventDefault();
                          e?.stopPropagation();
                          e.nativeEvent.stopImmediatePropagation();
                          if (!handleAction()) return;
                          handleFavorite();
                        }}
                        fill="var(--action-icon-clr)"
                        size={25}
                      />
                    </div>
                  ) : (
                    <div className={classes.iconWrapInner}>
                      <AiOutlineHeart
                        onClick={(e) => {
                          e.preventDefault();
                          e?.stopPropagation();
                          e.nativeEvent.stopImmediatePropagation();
                          if (!handleAction()) return;
                          handleFavorite();
                        }}
                        fill="white"
                        size={25}
                      />
                    </div>
                  )}
                </Tooltip>
              </div>
            )}
            {/* Tag */}
            {feature && (
              <div className={classes?.featuredPremiumContainer}>
                <span
                  className={`${
                    (data?.isFeatured && classes?.featuredIco) ||
                    (data?.isPremium && classes?.premiumIco)
                  }`}>
                  {data?.isFeatured && <TiStarFullOutline size={16} />}
                  {data?.isPremium && <FaCrown size={14} color="#FBC56C" />}
                  {(data?.isPremium && t('eventCard.premium')) ||
                    (data?.isFeatured && t('eventCard.featured'))}
                </span>
              </div>
            )}
            {/* Tag */}
          </div>
        </div>

        <Link to={`/events/${data?.slug}`}>
          <div className={classes.contentWrap} onClick={() => navigate(`/events/${data?.slug}`)}>
            <div className={classes.content}>
              <div className={classes.priceRow}>
                {!feature ? (
                  <div className={classes.price}>
                    <div className={[classes.mapRow, classes.mapPriceRows].join(' ')}>
                      <p>
                        {data?.price > 0
                          ? usdToOther({ amount: data?.price, ...currency })
                          : t('eventCard.openInvitation')}
                      </p>
                      {type === 'map' && (
                        <div
                          className={[
                            classes.iconWrap,
                            direction === 'ltr'
                              ? classes.mapIconWrapper
                              : classes.mapIconWrapperRight
                          ].join(' ')}>
                          <Tooltip text={t('eventCard.tooltips.compare')}>
                            <div
                              className={[classes.iconWrapInner, classes.mapIconWrapper].join(' ')}>
                              <BiTransfer
                                onClick={(e) => {
                                  e.preventDefault();
                                  e?.stopPropagation();
                                  e.nativeEvent.stopImmediatePropagation();
                                  if (!handleAction()) return;
                                  handleCompare(data);
                                }}
                                size={25}
                                fill={
                                  user?.compareList?.find((e) => e?.entity == data?._id)
                                    ? 'var(--action-icon-clr)'
                                    : 'white'
                                }
                              />
                            </div>
                          </Tooltip>
                          <Tooltip
                            text={
                              isFavorite
                                ? t('eventCard.tooltips.removeFavorite')
                                : t('eventCard.tooltips.addFavorite')
                            }>
                            {isFavorite ? (
                              <div className={classes.iconWrapInner}>
                                {' '}
                                <AiFillHeart
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e?.stopPropagation();
                                    e.nativeEvent.stopImmediatePropagation();
                                    if (!handleAction()) return;
                                    handleFavorite();
                                  }}
                                  fill="var(--action-icon-clr)"
                                  size={25}
                                />
                              </div>
                            ) : (
                              <div className={classes.iconWrapInner}>
                                <AiOutlineHeart
                                  onClick={(e) => {
                                    e.preventDefault();
                                    e?.stopPropagation();
                                    e.nativeEvent.stopImmediatePropagation();
                                    if (!handleAction()) return;
                                    handleFavorite();
                                  }}
                                  fill="white"
                                  size={25}
                                />
                              </div>
                            )}
                          </Tooltip>
                        </div>
                      )}
                    </div>
                    <div className={classes?.titleWrap}>
                      <p>{data?.title?.[selectedLanguage]}</p>
                      {type === 'map' && (
                        <div
                          className={`${classes?.logo} ${type === 'map' && classes.mapLogo}`}
                          onClick={(e) => {
                            e.preventDefault();
                            e?.stopPropagation();
                            e.nativeEvent.stopImmediatePropagation();
                            navigate(`/company/${data?.company?.slug}`);
                          }}>
                          <img src={imageUrl(data?.company?.photo)} />
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className={classes.price}>
                    <p>{data?.title?.[selectedLanguage]}</p>
                    <p>
                      {data?.price > 0
                        ? usdToOther({ amount: data?.price, ...currency })
                        : t('eventCard.openInvitation')}
                    </p>
                  </div>
                )}
              </div>

              <div className={classes.description}>
                <p>
                  {data?.description?.[selectedLanguage] &&
                    parser(data?.description?.[selectedLanguage])}
                </p>
              </div>
              <div className={classes.addressWrap}>
                <MdLocationOn fill="var(--secondary-clr)" />
                <p>{data?.address}</p>
              </div>

              {/* {!feature ? (
              <div className={classes.propertyDetailWrap}>
                <Row className={classes.gap}>
                  <Col md={6} className={classes.propertyDetail}>
                    <Tooltip text={t('eventCard.tooltips.eventType')}>
                      <AiFillInfoCircle color="var(--text-dark-gray-clr)" />
                    </Tooltip>
                    <p>{data?.eventType?.[selectedLanguage]}</p>
                  </Col>
                  <Col md={6} className={classes.propertyDetail}>
                    <Tooltip text={t('eventCard.tooltips.area')+' (sq ft)'}>
                      <BsGrid3X3Gap color="var(--text-dark-gray-clr)" />
                    </Tooltip>
                    <p>{data?.propertyArea}</p>
                  </Col>
                  <Col md={6} className={classes.propertyDetail}>
                    <Tooltip text={'Rooms'}>
                      <MdOutlineHotel color="var(--text-dark-gray-clr)" />
                    </Tooltip>
                    <p>{data?.noOfBedroooms}</p>
                  </Col>
                  <Col md={6} className={classes.propertyDetail}>
                    <Tooltip text={'Bathrooms'}>
                      <MdOutlineBathtub color="var(--text-dark-gray-clr)" />
                    </Tooltip>
                    <p>{data?.noOfBathrooms} Bathrooms</p>
                  </Col>
                </Row>
              </div>
            ) : ( */}
              <div className={classes.propertyDetailWrap}>
                <Row className={classes.gap}>
                  <Col md={6} className={classes.propertyDetail}>
                    <Tooltip text={t('eventCard.tooltips.eventType')}>
                      <CiCircleInfo color="var(--text-dark-gray-clr)" />
                    </Tooltip>
                    <p>{data?.eventType?.title?.[selectedLanguage]}</p>
                  </Col>

                  <Col md={6} className={classes.propertyDetail}>
                    <Tooltip text={t('eventCard.tooltips.date')}>
                      <TbCalendarTime color="var(--text-dark-gray-clr)" />
                    </Tooltip>
                    <p>{moment(data?.eventDate).format('ll')}</p>
                  </Col>
                </Row>
              </div>
              {/* )} */}
            </div>
            {/* {!feature ? (
            <div className={classes.key}>
              <ReactSVG src={keyDev} />
            </div>
          ) : ( */}
            <div className={classes.key1}>
              <div
                className={[
                  classes.socialIconsWrap1,
                  type === 'map' && classes.socialIconsWrapper
                ].join(' ')}>
                <div className={classes.socialIcons1}>
                  <Tooltip
                    text={t('eventCard.tooltips.call')}
                    onClick={(e) => {
                      e.preventDefault();
                      e?.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                    }}
                    href={`tel:${data?.phoneNumber}`}>
                    <MdPhoneInTalk fill="var(--primary-clr)" size={25} />
                  </Tooltip>
                </div>
                <div
                  className={[
                    classes.socialIcons1,
                    classes.midIcon,
                    type === 'map' && classes.socialMidIcons
                  ].join(' ')}
                  onClick={(e) => {
                    e.preventDefault();
                    e?.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    onEmailClick && onEmailClick();
                  }}>
                  <Tooltip text={t('eventCard.tooltips.email')}>
                    <MdEmail fill="var(--primary-clr)" size={28} />
                  </Tooltip>
                </div>
                <div className={classes.socialIcons1}>
                  <Tooltip
                    text={t('eventCard.tooltips.whatsapp')}
                    href={`https://wa.me/${data?.whatsapp}`}
                    target="_blank"
                    onClick={(e) => {
                      e.preventDefault();
                      e?.stopPropagation();
                      e.nativeEvent.stopImmediatePropagation();
                    }}>
                    <IoLogoWhatsapp fill="var(--primary-clr)" size={25} />
                  </Tooltip>
                </div>
              </div>
              {type !== 'map' && (
                <div
                  className={classes?.logo}
                  onClick={(e) => {
                    e.preventDefault();
                    e?.stopPropagation();
                    e.nativeEvent.stopImmediatePropagation();
                    navigate(`/company/${data?.company?.slug}`);
                  }}>
                  <img src={imageUrl(data?.company?.photo)} />
                </div>
              )}
            </div>
            {/* // )} */}
          </div>
        </Link>
      </div>
    </>
  );
};

export default EventCard;
